export enum ExportTemplateFormControls {
	ConnectorMode = 'connectorMode',
	ExportType = 'exportType',
	KeepOriginalLabels = 'keepOriginalLabels',
	Compress = 'compress',
	CsvConfig = 'csvConfig',
	TxtMetaConfig = 'txtConfig',
	XmlConfig = 'xmlConfig',
	ExcelConfig = 'excelConfig',
	DbConfig = 'dbConfig',
	WriteModeConfig = 'writeModeConfig',
	Path = 'path',
	FileNamePatternPrediction = 'fileNamePatternPrediction',
	Partitioning = 'partitioning',
	FileConfig = 'fileConfig',
}
